import { useMemoizedFn } from 'ahooks';
import React, { useState } from 'react';
import { Dialog, Link, Table } from 'tdesign-react';
import { renderDateTime } from '@/utils/common';
import useTable from '@/hooks/useTable';

export default function Instance({ row, request }) {
  const [visible, setVisible] = useState(false);

  const { instanceNum = 0 } = row;
  const columns = [
    {
      title: '实例id',
      colKey: 'instanceId',
    },
    {
      title: '接收消息数',
      colKey: 'numReceived',
    },
    {
      title: '写到pulsar的消息数目',
      colKey: 'numWritten',
      width: 200,
    },
    {
      title: '用户异常数',
      colKey: 'numUserExceptions',
    },
    {
      title: '系统异常数',
      colKey: 'numSystemExceptions',
    },
    {
      title: '重启次数',
      colKey: 'numRestarts',
    },
    {
      title: '最后调用时间',
      colKey: 'lastReceivedTime',
      cell: renderDateTime,
      width: 180,
    },
  ];

  const showDetail = () => {
    setVisible(true);
    doSearch();
  };

  const loadData = useMemoizedFn(async () => {
    const { data } = await request();
    setData(data);
  });

  const { config, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
    searchButton: null,
  });

  return (
    <>
      {instanceNum > 0 ? (
        <Link theme='primary' style={{ wordBreak: 'break-all' }} onClick={showDetail}>
          {row.instanceNum}
        </Link>
      ) : (
        instanceNum
      )}
      <Dialog
        visible={visible}
        width='80%'
        header='实例查看'
        footer={null}
        placement='center'
        onClose={() => setVisible(false)}
      >
        <Table {...config} />
      </Dialog>
    </>
  );
}
